import React from 'react';
import { Icon, Spin, StatusPill, InvPill, MarginChip, StatusDot,
         Drawer, Modal, Tabs, FG, RG, Pagination } from '../components/ui.jsx';
import { api, fmt, fmtD, dayN, showToast } from '../api.js';
import { ROLES, RL, TIPOLOGIE, REGIE, STATUSES, SL, INVOICE, MAT_CAT, MONTHS,
         STATUS_COLORS, INV_COLORS, PAGE_SIZE } from '../constants.js';


export const TechsPage =()=>{
  const [techs,setTechs]=React.useState([]);
  const [sel,setSel]=React.useState(null);
  const [modal,setModal]=React.useState(false);
  const [editMode,setEditMode]=React.useState(false);
  const [f,setF]=React.useState({name:'',slug:'',email:'',phone:'',roles:[],employment_type:'freelance',daily_rate:''});
  const [editF,setEditF]=React.useState(null);
  const [sav,setSav]=React.useState(false);
  const [offset,setOffset]=React.useState(0);
  const [total,setTotal]=React.useState(0);

  const load=()=>api(`/technicians?active=true&limit=${PAGE_SIZE}&offset=${offset}`).then(d=>{setTechs(d.items||d);setTotal(d.total||0);}).catch(()=>{});
  React.useEffect(()=>{load()},[offset]);

  const openDet=id=>api(`/technicians/${id}`).then(t=>{setSel(t);setEditMode(false);});

  const toggleR=(fObj,setFn,r)=>setFn(p=>({...p,
    roles:(p.roles||[]).includes(r)?p.roles.filter(x=>x!==r):[...(p.roles||[]),r]}));

  const saveNew=async()=>{
    if(!f.name.trim())return;setSav(true);
    try{await api('/technicians','POST',{...f,daily_rate:+(f.daily_rate||0)});
      setModal(false);setF({name:'',slug:'',email:'',phone:'',roles:[],employment_type:'freelance',daily_rate:''});load();
      showToast('Tecnico creato','success');}
    catch(e){/* toast globale in api.js */}
    finally{setSav(false);}
  };
  const saveEdit=async()=>{
    if(!editF)return;setSav(true);
    try{const up=await api(`/technicians/${editF.id}`,'PATCH',{
        name:editF.name,email:editF.email||null,phone:editF.phone||null,
        employment_type:editF.employment_type,daily_rate:+(editF.daily_rate||0),roles:editF.roles||[],wa_opt_in:editF.wa_opt_in!==false});
      setEditMode(false);setSel(await api(`/technicians/${up.id}`));load();showToast("Modifiche salvate","success");}
    catch(e){/* toast globale */}finally{setSav(false);}
  };
  const delTech = async (id, name) => {
    if (!window.confirm('Eliminare "'+ name +'"? Azione irreversibile.')) return;
    try { await api('/technicians/'+ id, 'DELETE'); setSel(null); load(); showToast('Eliminato','success'); }
    catch(e) { showToast(e?.body?.detail||'Errore eliminazione','error'); }
  };

  const deact=async id=>{
    if(!confirm('Disattivare?'))return;
    await api(`/technicians/${id}`,'PATCH',{active:false});setSel(null);load();
  };

  return(
    <div>
      <div className="page-header">
        <div className="page-title">Tecnici</div>
        <button className="btn btn-primary" onClick={()=>setModal(true)}>
          <Icon name="plus" size={14} color="#fff"/>Nuovo
        </button>
      </div>
      <div className="card" style={{padding:0}}>
        <table>
          <thead>
            <tr><th>Nome</th><th>Tipo</th><th>Tariffa/g</th><th>Ruoli</th><th>Contatti</th><th></th></tr>
          </thead>
          <tbody>
            {techs.map(t=>(
              <tr key={t.id} style={{cursor:'pointer',background:sel?.id===t.id?'var(--blue-50)':''}}
                onClick={()=>openDet(t.id)}>
                <td style={{fontWeight:600}}>{t.name}</td>
                <td><span className={`emp-badge emp-${t.employment_type||'freelance'}`}>{t.employment_type||'freelance'}</span></td>
                <td style={{fontWeight:600,color:'#B87D00'}}>{t.daily_rate>0?fmt(t.daily_rate):'-'}</td>
                <td>
                  {(t.roles||[]).slice(0,3).map(r=><span key={r} className="role-chip">{RL[r]||r}</span>)}
                  {(t.roles||[]).length>3&&<span className="role-chip">+{t.roles.length-3}</span>}
                </td>
                <td style={{fontSize:11,color:'var(--n400)'}}>
                  {t.email&&<div>{t.email}</div>}
                  {t.phone&&<div>{t.phone}</div>}
                </td>
                <td style={{textAlign:'right'}}>
                  <button className="btn btn-ghost btn-sm" style={{padding:'5px 7px'}}
                    onClick={e=>{e.stopPropagation();
                      api(`/technicians/${t.id}`).then(ft=>{setSel(ft);setEditF({...ft,daily_rate:ft.daily_rate||''});setEditMode(true);});}}>
                    <Icon name="pencil" size={13} color="var(--n500)"/>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Drawer dettaglio / modifica */}
      <Drawer
        open={!!sel}
        onClose={()=>{setSel(null);setEditMode(false);}}
        title={sel?.name}
        subtitle={editMode?'Modifica profilo':sel?.employment_type}
        width={440}
        actions={!editMode?
          <button className="btn btn-ghost btn-sm"
            onClick={()=>{setEditF({...sel,daily_rate:sel.daily_rate||''});setEditMode(true);}}>
            <Icon name="pencil" size={13} color="var(--n500)"/>Modifica</button>:null}
      >
        {sel&&!editMode&&(
          <div>
            <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:16,
              padding:'14px 16px',background:'var(--n50)',borderRadius:10}}>
              <div style={{width:44,height:44,borderRadius:'50%',
                background:'var(--blue-50)',border:'2px solid var(--blue-pale)',
                display:'flex',alignItems:'center',justifyContent:'center',
                fontSize:18,fontWeight:700,color:'var(--blue)'}}>
                {sel.name.charAt(0)}
              </div>
              <div>
                <div style={{fontWeight:700,fontSize:16}}>{sel.name}</div>
                <div style={{display:'flex',alignItems:'center',gap:8,marginTop:4}}>
                  <span className={`emp-badge emp-${sel.employment_type||'freelance'}`}>{sel.employment_type||'freelance'}</span>
                  {sel.daily_rate>0&&<span style={{fontSize:13,color:'#B87D00',fontWeight:600}}>{fmt(sel.daily_rate)}/g</span>}
                </div>
              </div>
            </div>

            <div style={{marginBottom:14}}>
              {(sel.roles||[]).map(r=><span key={r} className="role-chip" style={{color:'var(--blue-dark)'}}>{RL[r]||r}</span>)}
              {!(sel.roles||[]).length&&<span style={{fontSize:12,color:'var(--n400)'}}>Nessun ruolo</span>}
            </div>

            {sel.email&&<div style={{fontSize:12,color:'var(--n400)',marginBottom:6,
              display:'flex',alignItems:'center',gap:6}}>
              <Icon name="mail" size={12} color="var(--n400)"/>{sel.email}</div>}
            {sel.phone&&<div style={{fontSize:12,color:'var(--n400)',marginBottom:14,
              display:'flex',alignItems:'center',gap:6}}>
              <Icon name="phone" size={12} color="var(--n400)"/>{sel.phone}</div>}

            <div style={{fontSize:11,color:'var(--n400)',textTransform:'uppercase',
              letterSpacing:'.06em',fontWeight:700,marginBottom:8}}>Prossimi cantieri</div>
            {(sel.upcoming_events||[]).map(e=>(
              <div key={e.id} className="crew-slot" style={{marginBottom:4}}>
                <div>
                  <span style={{fontSize:11,color:'var(--blue)',fontWeight:600}}>{e.code}</span>
                  <span style={{fontWeight:500,fontSize:13,marginLeft:6}}>{e.title}</span>
                  <div style={{fontSize:11,color:'var(--n400)'}}>{fmtD(e.date_start)}   {RL[e.role]||e.role}</div>
                </div>
              </div>
            ))}
            {!(sel.upcoming_events||[]).length&&
              <div style={{fontSize:12,color:'var(--n400)'}}>Nessun cantiere prossimo</div>}

            <div style={{marginTop:20,paddingTop:14,borderTop:'1px solid var(--n100)'}}>
              <button style={{background:'var(--danger-bg)',color:'var(--danger)',
                border:'1px solid var(--blue-pale)',borderRadius:7,
                padding:'6px 12px',fontSize:12,fontWeight:600,cursor:'pointer',
                display:'inline-flex',alignItems:'center',gap:6}}
                onClick={()=>deact(sel.id)}>
                <Icon name="user-x" size={13} color="var(--danger)"/>Disattiva tecnico
              </button>
            </div>
          </div>
        )}

        {sel&&editMode&&editF&&(
          <div>
            <div className="grid grid-2">
              <FG label="Nome *" span={2}>
                <input className="input" value={editF.name}
                  onChange={e=>setEditF(p=>({...p,name:e.target.value}))}/>
              </FG>
              <FG label="Email">
                <input className="input" value={editF.email||''}
                  onChange={e=>setEditF(p=>({...p,email:e.target.value}))}/>
              </FG>
              <FG label="WhatsApp">
                <input className="input" value={editF.phone||''}
                  onChange={e=>setEditF(p=>({...p,phone:e.target.value}))}/>
                <label style={{display:'flex',alignItems:'center',gap:6,marginTop:6,fontSize:12,color:'var(--n600)',cursor:'pointer'}}>
                  <input type="checkbox"
                    checked={editF.wa_opt_in !== false}
                    onChange={e=>setEditF(p=>({...p,wa_opt_in:e.target.checked}))}/>
                  Invia notifiche via WhatsApp
                </label>
              </FG>
              <FG label="Tipo contratto">
                <select className="input" value={editF.employment_type||'freelance'}
                  onChange={e=>setEditF(p=>({...p,employment_type:e.target.value}))}>
                  <option value="freelance">Freelance</option>
                  <option value="dipendente">Dipendente</option>
                </select>
              </FG>
              <FG label="Tariffa giornaliera (-)">
                <input type="number" min="0" className="input" value={editF.daily_rate}
                  onChange={e=>setEditF(p=>({...p,daily_rate:e.target.value}))}/>
              </FG>
            </div>
            <FG label="Ruoli abilitati">
              <RG roles={editF.roles} onChange={r=>toggleR(editF,setEditF,r)}/>
            </FG>
            <div style={{display:'flex',justifyContent:'space-between',gap:8,marginTop:16}}>
              <button className="btn" style={{background:'var(--danger)',color:'#fff'}} onClick={()=>delTech(sel.id,sel.name)}>
                <Icon name="trash-2" size={13} color="#fff"/>Elimina</button>
              <div style={{display:'flex',gap:8}}>
                <button className="btn btn-ghost" onClick={()=>setEditMode(false)}>Annulla</button>
                <button className="btn btn-primary" onClick={saveEdit} disabled={sav}>
                  <Icon name="save" size={13} color="#fff"/>{sav?'Salvataggio...':'Salva'}
                </button>
              </div>
            </div>
          </div>
        )}
      </Drawer>

      {/* Modal nuovo tecnico */}
      {modal&&(
        <Modal title="Nuovo tecnico" onClose={()=>setModal(false)}>
          <div className="grid grid-2">
            <FG label="Nome *" span={2}>
              <input autoFocus className="input" value={f.name}
                onChange={e=>setF(p=>({...p,name:e.target.value,
                  slug:e.target.value.toLowerCase().replace(/\s+/g,'-').replace(/[^a-z0-9-]/g,'')}))}/>
            </FG>
            <FG label="Email">
              <input className="input" value={f.email} onChange={e=>setF(p=>({...p,email:e.target.value}))}/></FG>
            <FG label="WhatsApp">
              <input className="input" value={f.phone} onChange={e=>setF(p=>({...p,phone:e.target.value}))}/></FG>
            <FG label="Tipo contratto">
              <select className="input" value={f.employment_type}
                onChange={e=>setF(p=>({...p,employment_type:e.target.value}))}>
                <option value="freelance">Freelance</option>
                <option value="dipendente">Dipendente</option>
              </select>
            </FG>
            <FG label="Tariffa/g (-)">
              <input type="number" min="0" className="input" value={f.daily_rate}
                onChange={e=>setF(p=>({...p,daily_rate:e.target.value}))}/>
            </FG>
          </div>
          <FG label="Ruoli abilitati">
            <RG roles={f.roles} onChange={r=>toggleR(f,setF,r)}/>
          </FG>
          <div style={{display:'flex',justifyContent:'flex-end',gap:8,marginTop:14}}>
            <button className="btn btn-ghost" onClick={()=>setModal(false)}>Annulla</button>
            <button className="btn btn-primary" onClick={saveNew} disabled={sav}>
              <Icon name="save" size={13} color="#fff"/>{sav?'Salvataggio...':'Salva'}
            </button>
          </div>
        </Modal>
      )}
    </div>
  );
};

